import React from "react";
import { useParallaxInView } from "../../lib/hooks";
import { Section } from "../section/section.component";
import { base, containers } from "../../styles/base/_allBase.styles";
import Content from "../block-content/block-content";
import { analyticsModuleAttributes } from "../../lib/analytics-content.mjs";

const { H3, StyleP } = base;
const { TwoColumnGrid, GridItem, SectionHeaderContainer } = containers;

const HeaderTwoColumGrid = React.memo(function HeaderTwoColumGrid({
  data,
  staticLayout = false,
}) {
  const { y, ref, isInView } = useParallaxInView(-50);
  const motionStyle = staticLayout ? undefined : { y };

  return (
    <Section
      style={{ zIndex: 1 }}
      cursorsize={"small"}
      size={"auto"}
      {...analyticsModuleAttributes(data, "two_column_content", undefined, data.header)}
    >
      <SectionHeaderContainer>
        <H3 style={motionStyle} color="primary">
          {data.header}
        </H3>
      </SectionHeaderContainer>
      <TwoColumnGrid ref={ref} style={motionStyle}>
        <GridItem position={"left"}>
          <StyleP color="primary">
            <Content blocks={data.text[0].text} />
          </StyleP>
        </GridItem>
        <GridItem position={"right"}>
          <StyleP color="primary">
            <Content blocks={data.text[1].text} />
          </StyleP>
        </GridItem>
      </TwoColumnGrid>
    </Section>
  );
});

export { HeaderTwoColumGrid };
